import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  forwardRef,
} from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import chroma from "chroma-js";

const COLOR_PICKER_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => ColorPickerComponent),
  multi: true,
};

@Component({
    selector: "ts-color-picker",
    templateUrl: "./color-picker.component.html",
    styleUrls: ["./color-picker.component.scss"],
    providers: [COLOR_PICKER_VALUE_ACCESSOR],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ColorPickerComponent implements ControlValueAccessor {
  hexValue: string | null = null;
  textValue = "";
  disabled = false;

  private onChange: (value: string | null) => void = () => undefined;
  private onTouched: () => void = () => undefined;

  constructor(private readonly cdr: ChangeDetectorRef) {}

  writeValue(value: string | null): void {
    const hex = toHex(value);
    this.hexValue = hex;
    this.textValue = hex ?? "";
    this.cdr.markForCheck();
  }

  registerOnChange(fn: (value: string | null) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
    this.cdr.markForCheck();
  }

  onSwatchChange(value: string): void {
    const hex = toHex(value);
    if (!hex) return;
    this.hexValue = hex;
    this.textValue = hex;
    this.onChange(hex);
    this.onTouched();
  }

  onTextChange(value: string): void {
    this.textValue = value;
    const hex = toHex(value);
    if (!hex) return;
    this.hexValue = hex;
    this.onChange(hex);
    this.onTouched();
  }
}

function toHex(value: string | null | undefined): string | null {
  if (!value) return null;
  try {
    return chroma(value).hex("rgb");
  } catch {
    return null;
  }
}
